import { useNonF2fMedicalCategories } from '@/entities/medical-category';
import { EMedicalCategoryCategory, MedicalCategoryModel } from '@/entities/medical-category/model/MedicalCategory';
import { DiagnosisCategoryType } from '@/models/diagnosis';

import { useTelemedicineRequest } from '@/entities/telemedicine';
import { ROUTES } from '@/types/common';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';

const DIET_TREATMENT_ID = '12';
const MEDICINE_UNIT_ID = 185;
const DEFAULT_REGION_CODE = 11;
const MORE_CATEGORY_PATH = `${ROUTES.TELEMEDICINE.CATEGORIES.path}`;

const MORE_CATEGORY = {
  id: 'more',
  name: '전체 보기',
  iconUrl: 'https://d2m9duoqjhyhsq.cloudfront.net/diagnoses/etc/more_category.png',
};

const mapMedicalCategoryToRouteType = (category: string): DiagnosisCategoryType => {
  if (category.toLowerCase() === 'treatment') {
    return DiagnosisCategoryType.Treatment;
  }

  if (category.toLowerCase() === 'department') {
    return DiagnosisCategoryType.Department;
  }

  if (category.toLowerCase() === 'vaccination') {
    return DiagnosisCategoryType.Vaccination;
  }

  return DiagnosisCategoryType.Treatment;
};

const useMedicalCategoryDisplayViewModel = (size = MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE - 1) => {
  const { onClickTelemedicineRequest } = useTelemedicineRequest();
  const { medicalCategories, isLoading, error } = useNonF2fMedicalCategories(size);

  const getCategoryPath = (category: MedicalCategoryModel) => {
    if ('category' in category && category.category === 'TREATMENT' && category.id === DIET_TREATMENT_ID) {
      return `${ROUTES.NON_BENEFIT.HOME.path}?treatmentId=${category.id}&treatmentMedicineUnitId=${MEDICINE_UNIT_ID}&regionCode=${DEFAULT_REGION_CODE}`;
    }

    return `${ROUTES.TELEMEDICINE.REQUEST.path}?categoryId=${category.id}&type=${mapMedicalCategoryToRouteType(category.category)}`;
  };

  const onClickCategory = (category: MedicalCategoryModel) => {
    onClickTelemedicineRequest({
      categoryId: category.id,
      type:
        category.category === EMedicalCategoryCategory.TREATMENT
          ? DiagnosisCategoryType.Treatment
          : DiagnosisCategoryType.Department,
      redirectUrl: getCategoryPath(category),
    });
  };

  return {
    medicalCategories: medicalCategories,
    moreCategory: MORE_CATEGORY,
    isLoading,
    error,
    moreCategoryPath: MORE_CATEGORY_PATH,
    getCategoryPath,
    onClickCategory,
  };
};

export default useMedicalCategoryDisplayViewModel;
